import { __extends } from "tslib";
import { GetSegmentDetectionRequest, GetSegmentDetectionResponse } from "../models/models_0";
import { deserializeAws_json1_1GetSegmentDetectionCommand, serializeAws_json1_1GetSegmentDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetSegmentDetectionCommand = /** @class */ (function (_super) {
    __extends(GetSegmentDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetSegmentDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetSegmentDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "RekognitionClient";
        var commandName = "GetSegmentDetectionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetSegmentDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetSegmentDetectionResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetSegmentDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetSegmentDetectionCommand(input, context);
    };
    GetSegmentDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetSegmentDetectionCommand(output, context);
    };
    return GetSegmentDetectionCommand;
}($Command));
export { GetSegmentDetectionCommand };
//# sourceMappingURL=GetSegmentDetectionCommand.js.map